// Single-source AI marker glyph.
//
// Per KB variants design handoff (§6 resolutions, 2026-07-07):
//   "✦ is the house AI marker for now. Always aria-hidden, always paired with
//    visible text — never carries meaning alone."
//
// If we ever adopt a different house AI icon (SVG asset, custom font glyph,
// etc.), swap the character in this single file and every trigger + provenance
// tag across the admin SPA updates in one shot.
//
// USAGE: always render inside a button / span with adjacent visible text. Do
// NOT use as a bare icon in an interactive control — screen readers get
// nothing from it.

export function AIGlyph() {
  return (
    <span aria-hidden="true" style={{ display: 'inline-block' }}>
      ✦
    </span>
  );
}
